/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Solo_NameInputs */

const en_cp_p_solo_name = /** @type {(inputs: Cp_P_Solo_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual student`)
};

const id_cp_p_solo_name = /** @type {(inputs: Cp_P_Solo_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahasiswa perorangan`)
};

/**
* | output |
* | --- |
* | "Individual student" |
*
* @param {Cp_P_Solo_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_solo_name = /** @type {((inputs?: Cp_P_Solo_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Solo_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_solo_name(inputs)
	return en_cp_p_solo_name(inputs)
});